import React from 'react';
import { css, FlattenSimpleInterpolation } from 'styled-components';

import { Container, InnerContainer } from './centerContainer.styles';

export interface CenterContainerProps {
  children: React.ReactNode;
  customStyles?: FlattenSimpleInterpolation;
  role?: string;
}

export const CenterContainer = ({ children, customStyles = css``, role }: CenterContainerProps) => (
  <Container customStyles={customStyles} role={role}>
    <InnerContainer>{children}</InnerContainer>
  </Container>
);
